// extracted by mini-css-extract-plugin
module.exports = {"feedbackPage":"feedback-module--feedback-page--3APrl","container":"feedback-module--container--3iQDp","formHolder":"feedback-module--form-holder--OZc59"};